import { Tab } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekTab = styled(Tab)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.h4), { minWidth: theme.spacing(10), minHeight: theme.spacing(4.8), textTransform: "capitalize", color: theme.palette.text.primary, borderBottom: `2px solid transparent`, "&.Mui-selected": {
        color: theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightMedium,
        borderBottomColor: theme.palette.text.primary,
    }, "&.Mui-disabled": {
        pointerEvents: "all",
        cursor: "not-allowed",
    } })));

export { PeekTab, PeekTab as default };
